// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: entry points for the task UI shared by the page, slash commands and menus.

import {KonvoTaskModal} from '@app/features/konvo_tasks/components/KonvoTaskModal';
import DesktopWorkspaceUi from '@app/features/konvo_tasks/components/workspace/desktop/DesktopWorkspaceUi';
import {openNewTaskModal} from '@app/features/konvo_tasks/components/workspace/desktop/NewTaskModal';
import KonvoWorkspace from '@app/features/konvo_tasks/state/KonvoWorkspace';
import {workspacePath} from '@app/features/konvo_tasks/state/WorkspaceLocation';
import {KonvoCreateTaskModal} from '@app/features/messaging/components/modals/KonvoCreateTaskModal';
import Navigation from '@app/features/navigation/state/Navigation';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import MobileLayout from '@app/features/ui/state/MobileLayout';

/** `url`: the ClickUp link it was opened from, offered when Konvo cannot load the task. */
export function openKonvoTask(taskId: string, initialSection: 'overview' | 'time' = 'overview', url?: string): void {
	ModalCommands.push(
		modal(() => (
			<KonvoTaskModal initialSection={initialSection} taskId={taskId} url={url} onClose={() => ModalCommands.pop()} />
		)),
	);
}

export function openKonvoCreateTask(initialName?: string, onCreated?: (task: {id: string; url: string}) => void): void {
	// Desktop: the workspace New task modal (every list, its statuses and members). The phone,
	// and anyone without ClickUp connected, keep the light modal with its connect prompt.
	const phone = MobileLayout.platformMobileDetected || MobileLayout.enabled;
	if (!phone && KonvoWorkspace.connected !== false) {
		openNewTaskModal({name: initialName, onCreated});
		return;
	}
	ModalCommands.push(
		modal(() => (
			<KonvoCreateTaskModal initialName={initialName} onCreated={onCreated} onClose={() => ModalCommands.pop()} />
		)),
	);
}

/** The task on the Tasks page: its list with the task open beside it (desktop), or its card (phone). */
export function openKonvoTaskInWorkspace(taskId: string, listId: string | null): void {
	const phone = MobileLayout.platformMobileDetected || MobileLayout.enabled;
	if (phone || !listId) {
		openKonvoTask(taskId);
		return;
	}
	DesktopWorkspaceUi.queueOpenTask(taskId);
	Navigation.navigateToTasksPath(workspacePath({kind: 'list', id: listId}));
}

export function openKonvoTasksPage(): void {
	Navigation.navigateToTasks();
}
